import format from 'date-fns/format'
import React from 'react';

const notAvailable = (value, transform) => value ? transform ? transform(value) : value : "N/A";

const mapValue = (value, lookup, accessor) => {
    if (lookup[value] === undefined)
        return "Unknown";

    return accessor !== undefined ? accessor(lookup[value]) : lookup[value];
}

const padZeroes = (n, z) => {
    z = z || 2;
    return ('00' + n).slice(-z);
}

const formatDate = (date, includeYear = true) => {
    const formattedDate = format(date, "PPP");
    return (includeYear ? formattedDate : formattedDate.split(",")[0]).trimEnd();
}

const formatTime = (date) => date && format(date, `pppp`);
const formatTimeZone = (date) => date && format(date, `OOOO`);

const formatDateTime = (date) => date && `${formatDate(date)} ${format(date, `pp`)}`;

const formatDateTimeString = (str) => str ? formatDateTime(new Date(str)) : "" ;

const formatDateString = (str, includeYear = true) => formatDate(new Date(str), includeYear);

const formatMillisecondTime = (curr) => {
    const divisions = [1000, 60, 60, 24]
    const amounts = []

    for (let d of divisions) {
        let next = curr % d;
        amounts.push(next);
        curr = (curr - next) / d;
    }

    return amounts.slice(1).reverse().map(n => padZeroes(n)).join(":");
}

const formatMillisecondReadbleTime = (ms) => {
    const divisions = [1000, 60, 60, 24];
    const units = ['second', 'minute', 'hour', 'day'];
    const unitsPlural = ['seconds', 'minutes', 'hours', 'days'];

    let readableTime = "";
    let multiplier = 1;
    for (let i = 0; i < divisions.length; i++) {
        multiplier = multiplier * divisions[i];
        const upperLimit = i === divisions.length ? null : divisions[i + 1];
        let time = (ms / multiplier);
        if (upperLimit == null || time < upperLimit) {
            readableTime = `${time} ${time === 1 ? units[i] : unitsPlural[i]}`;
            break;
        }
    }
    return readableTime;
}

const formatByteSize = (size) => {
    const suffixes = ["B", "KB", "MB", "GB", "TB", "PB"];
    let index = 0;

    while (size >= 1024) {
        index += 1;
        size /= 1024;
    }
    return `${size.toFixed(2)} ${suffixes[index]}`;
}

const isToday = (str) => {
    const date = new Date(str);
    const today = new Date();
    return date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear();
}

const formatMultilineString = (str) => str && str.split('\n').map((line, i) => (
    <span key={i}>
        {line}
        <br />
    </span>
));

const utility = {
    notAvailable,
    padZeroes,
    formatMillisecondTime,
    formatMillisecondReadbleTime,
    formatByteSize,
    mapValue,
    formatDate,
    formatDateString,
    formatTime,
    formatTimeZone,
    formatDateTime,
    formatDateTimeString,
    formatMultilineString,
    isToday
};

export default utility;